import { css } from '@emotion/react'

export const GlobalStyles = css`
  @import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard-dynamic-subset.css');
  * {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    box-sizing: border-box;
    font-size: 16px;
    font-family: 'pretendard';
    font-weight: 400;
    color: #f9f9fb;
  }
  b {
    font-weight: bold;
  }

  .App {
    background-color: #030303;
    min-height: 100vh;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  img {
    height: auto;
    max-width: 100%;
  }
  button {
    background: none;
    color: inherit;
    cursor: pointer;
  }

  .flex_center {
    display: flex;
    align-items: center;
  }

  .pointer {
    cursor: pointer;
  }
  a {
    text-decoration: none;
  }
  .pc_max_width {
    max-width: 1100px;
  }
`

export default GlobalStyles
